import { render, staticRenderFns } from "./NavBarSiteSwitcher.vue?vue&type=template&id=2ea03831&"
import script from "./NavBarSiteSwitcher.vue?vue&type=script&lang=js&"
export * from "./NavBarSiteSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./NavBarSiteSwitcher.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports